import React from 'react';
import { IoCalendarOutline, IoClose } from 'react-icons/io5';
import { IconButton, Typography } from '@material-tailwind/react';
import { DateRange } from '../DateTimePicker';

interface DatePickerInputProps {
  id: string;
  dateRange: DateRange;
  handleClearSelection: (e: React.MouseEvent<HTMLButtonElement>) => void;
  timeFormat: '12' | '24';
  isLocked?: boolean;
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({
  id,
  dateRange,
  handleClearSelection,
  timeFormat,
  isLocked,
}) => {
  const formatDateTime = (date: Date) => {
    if (timeFormat === '12') {
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString('en', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })}`;
    }
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  };

  if (dateRange.startDate && dateRange.endDate) {
    return (
      <>
        <Typography 
          variant="h6" 
          className="font-normal text-[15px] text-neutral-grey800 leading-none truncate max-w-full"
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          {formatDateTime(dateRange.startDate)} - {formatDateTime(dateRange.endDate)}
        </Typography>
        <IconButton
          variant="text"
          className="rounded-full !m-0 !p-0 h-4 w-4"
          disabled={isLocked}
          id={`${id}-clear`}
          onClick={handleClearSelection}
          placeholder=""
          onResize={() => {}}
          onResizeCapture={() => {}}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          <IoClose size={14} className="text-blue-500" />
        </IconButton>
      </>
    );
  }

  return (
    <>
      <Typography 
        variant="h6" 
        className="uppercase font-normal text-[14px] pt-0.5 text-neutral-grey400 leading-none"
        placeholder=""
        onResize={() => {}}
        onResizeCapture={() => {}}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        dd-mm-yyyy - dd-mm-yyyy
      </Typography>
      <IoCalendarOutline id={`${id}-open`} className="w-[17px] h-[17px] text-neutral-grey400" />
    </>
  );
};

export default DatePickerInput; 